import { useState, useEffect, useRef } from "react";
import { findBoundsOfArrayOfItems } from "../../../refractCommon/miro/findBoundsOfArrayOfItems";

const { board } = window.miro;

export default function RotateNormal({ boardSelection }) {
  const [targetIsSet, setTargetSet] = useState(false);
  const [targetItem, setTargetItem] = useState({});
  const [rotationOffset, setRotationOffset] = useState(0);
  const [toolOpen, setToolOpen] = useState(false);
  const [setHeight, setHeightState] = useState("0px");

  const content = useRef(null);

  function handleToggleOpen() {
    setToolOpen(!toolOpen);
    setHeightState(toolOpen ? "0px" : `${content.current.scrollHeight}px`);
  }

  //
  //  FUNCTIONAL CODE
  async function runSetTarget() {
    let selection = await board.getSelection();
    if (selection.length > 0) {
      if (selection.length === 1) {
        setTargetSet(true);
        setTargetItem(selection[0]);
      }
    } else if (selection.length === 0) {
      setTargetSet(false);
      setTargetItem({});
    }
  }

  // ROTATE TOOL APPLICABLE ITEM TYPES
  function runFilterSelectionForRotateNormal(selection) {
    let filteredSelection = selection.filter(
      (item) =>
        item.type === "text" ||
        item.type === "card" ||
        item.type === "shape" ||
        item.type === "image"
    );

    // setBoardSelection(filteredSelection);
    return filteredSelection;
  }
  // ROTATE NORMAL TOOL APPLICABLE ITEM TYPE ICONS TO MATCH
  const rotateNormalTypeIcons = (
    <div className="cs5 ce12 grid">
      <div className="m2 icon icon-rectangle cs1"></div>
      <div className="m2 icon icon-card cs2"></div>
      <div className="m2 icon icon-text cs3"></div>
      <div className="m2 icon icon-image cs4"></div>
    </div>
  );

  async function runRotateNormal(flag) {
    if (boardSelection.length > 0) {
      let selection = await board.getSelection();
      let filteredSelection = runFilterSelectionForRotateNormal(selection);

      if (flag === "centroid") {
        let { centroidX, centroidY } =
          findBoundsOfArrayOfItems(filteredSelection);
        for (const item of filteredSelection) {
          let normalRotationDegrees = findNormalDegreesCounterClockwise(
            item,
            centroidX,
            centroidY
          );
          // add the offset
          normalRotationDegrees = normalRotationDegrees + rotationOffset;

          item.rotation = -normalRotationDegrees;
          await item.sync();
        }
      }
      if (flag === "target") {
        let centerX = targetItem.x;
        let centerY = targetItem.y;
        for (const item of filteredSelection) {
          let normalRotationDegrees = findNormalDegreesForTarget(
            item,
            centerX,
            centerY
          );
          // add the offset
          normalRotationDegrees = normalRotationDegrees + rotationOffset;

          item.rotation = normalRotationDegrees;
          await item.sync();
        }
      }
    }
  }

  async function runRotateReset() {
    if (boardSelection.length > 0) {
      let selection = await board.getSelection();
      let filteredSelection = runFilterSelectionForRotateNormal(selection);
      for (const item of filteredSelection) {
        item.rotation = 0;
        await item.sync();
      }
    }
  }

  function findNormalDegreesCounterClockwise(item, centerX, centerY) {
    let dX = centerX - item.x;
    let dY = item.y - centerY;
    let radianTheta = Math.atan2(dY, dX);

    var pi = Math.PI;
    return radianTheta * (180 / pi);
  }

  function findNormalDegreesForTarget(item, centerX, centerY) {
    let dX = centerX - item.x;
    let dY = item.y - centerY;
    let pi = Math.PI;

    if (dX < 0) {
      let radianTheta = Math.atan(dY / dX);
      return radianTheta * -(180 / pi) + 180;
    } else {
      let radianTheta = Math.atan(dY / dX);
      return radianTheta * -(180 / pi);
    }
  }

  return (
    <div id="rotate-normal-tool" className="grid tool-section mt-0 pb-0">
      <div
        id="...-tool-header"
        className={"grid cs1 ce12 mt-0 cursor-pointer"}
        onClick={(event) => {
          handleToggleOpen();
        }}>
        <div className="icon m2 icon-collapse cs1"></div>
        <h3 className="h3 cs2 ce11 mt-0 pb-0 mb-0">Aim at Center or Target</h3>
        <div
          className={
            "cs12 icon m2 mb-0 mt-0 cursor-pointer" +
            " " +
            (toolOpen === false ? " icon-arrow-right" : " icon-arrow-down")
          }></div>
      </div>

      <div
        id="accordion-content"
        ref={content}
        style={{ maxHeight: `${setHeight}` }}
        className="cs1 ce12 grid accordion">
        <div id="accordion-margin" className="cs1 ce12 grid mb-8">
          <p className="p-medium mt-0 pt-0 cs1 ce12 mb-0">
            Rotate items so they each point at their group's center or at a
            chosen target.
          </p>

          <div
            id="circle-works-on"
            className="help-container grid cs1 ce12 mt-0 mb-8 pt-8">
            <p className="p-small cs1 ce4 mb-0 mt-0">
              Works on
              <b> many:</b>
            </p>
            {rotateNormalTypeIcons}
          </div>
          {/*  */}
          <div className="p-large cs1 ce12 mb-0">Aim at Center</div>
          <button
            type="button"
            className="button button-primary button-small cs1 ce12 mb-8 mr-0 "
            onClick={() => runRotateNormal("centroid")}>
            Aim at Centroid
          </button>
          <div className="p-large cs1 ce12">Aim at a Target</div>
          <button
            type="button"
            className="button button-primary button-small cs1 ce6 mb-0 mt-0 mr-0  "
            onClick={runSetTarget}>
            Set Target
          </button>
          {/* <div
        className="p-small mt-0 mb-0 cs5 ce8 align-center pt-8 pb-8"
        style={{ backgroundColor: "var(--indigo300)" }}>
        {targetIsSet ? "Set" : "Not Set"}
      </div> */}

          <button
            type="button"
            disabled={!targetIsSet}
            className="button button-primary button-small cs7 ce12 mb-0 mt-0 mr-0 "
            onClick={() => runRotateNormal("target")}>
            Aim at Target
          </button>

          {/* <label className="toggle mb-0 cs1 ce12 ml-0">
        <input
          type="checkbox"
          tabIndex="0"
          onChange={() => {
            setAdd90(!add90);
          }}
        />
        <span>+90°</span>
      </label> */}
          <div className="cs1 ce6 grid mb-0 mt-8">
            <div className="cs1 ce12">
              <p className="p-medium mb-0 mt-0 pb-0 cs1 ce12">
                <b>{rotationOffset}°</b> Offset
              </p>
            </div>

            <div className="slidecontainer cs1 ce12 mb-0 mt--12">
              <input
                type="range"
                min="0"
                max="360"
                value={rotationOffset}
                className="slider extended"
                onChange={(e) => {
                  setRotationOffset(Number(e.target.value));
                }}
                // onMouseUp={() => {}}
                id="rotation offset"
              />
            </div>
          </div>

          <button
            type="button"
            className="button button-secondary fix-button-secondary button-small cs8 ce12 mt-8"
            onClick={runRotateReset}>
            Reset Rotations
          </button>
        </div>
      </div>
    </div>
  );
}
